import { Inject, Injectable } from "@angular/core";
import {  BrandBannerResponse, BrandBannerTranslation, SubmitResponse } from "../../../models";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { BrandBannerData } from "../../../models/admin/brandBanner.model";


@Injectable({
    providedIn: 'root'
})
export class BrandBannerService extends HttpService<any, BrandBannerData | BrandBannerTranslation |BrandBannerResponse> {
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'brand/banners');
    }

    getAllBrandBanners(page = 1, limit?: number): Observable<BrandBannerData> {
        return this.getAllPaged('admin/list', page, '', limit) as Observable<BrandBannerData>;
    }


    deleteBanner(bannerId: string): Observable<SubmitResponse> {
        return this.delete(bannerId).pipe(catchError((error) => of(error)));
    }
    createBrandBanner(mediaInput: any): Observable<BrandBannerTranslation> {
        return this.create(mediaInput).pipe(catchError((error) => of(error)));
    }
    updateBrandBanner(id: string, mediaInput: any): Observable<BrandBannerTranslation> {
        return this.update(mediaInput, id).pipe(catchError((error) => of(error)));
    }

    updateBannerOrder(payload: any): Observable<SubmitResponse> {
        return this.update(payload, 'positions/align').pipe(catchError((error) => of(error)));
    }
    getBrandBannerById(id: number): Observable<BrandBannerResponse> {
        return this.getById(id,'admin') as Observable<BrandBannerResponse>;
    }





}
